import { StyleSheet } from "react-native"
import { typography } from "theme"

export const styles = StyleSheet.create({
  checkboxBase: {
    alignItems: "center",
    borderColor: "#555",
    borderRadius: 4,
    borderWidth: 2,
    display: "flex",
    height: 18,
    justifyContent: "center",
    marginRight: 8,
    width: 18,
  },
  checkboxChecked: {
    backgroundColor: "#4CAF50",
    borderColor: "#4CAF50",
  },
  checkboxUnchecked: {
    backgroundColor: "#f0f0f0",
  },
  container: {
    alignItems: "center",
    flexDirection: "row",
    flex: 1,
  },
  label: {
    color: "#333",
    fontFamily: typography.primary.normal,
    fontSize: 14,
  },
  tickIcon: {
    color: "#fff",
    fontSize: 12,
  },
})
